import useStyles from './TimerItem.styled'

export const useTimerItem = props => {
	const { timeRemaining, label } = props
	const classes = useStyles(props)

	return [{ classes, timeRemaining, label }]
}
